import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3081c147"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "header-menu_items flex"
}
const _hoisted_2 = { href: "/" }
const _hoisted_3 = {
  key: "expanded",
  class: "aside-main_sticky_logo-wrapper_mask_image",
  src: "https://dam.malt.com/navbar/logos/malt-logo-red.svg?vh=9690b2",
  width: "100",
  height: "28",
  alt: "Malt logo"
}
const _hoisted_4 = { class: "header-menu_actions flex" }

import {useAsideMenu, useDisplayMode} from '@/logged/features/aside-menu';
    import {useUser} from '@/logged/features/user';
    import {useHeaderMenu} from '@/logged/features/header-menu';
    import {storeToRefs} from 'pinia';
    import HeaderMenuItem from './HeaderMenuItem.vue';
    import {computed} from 'vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import HeaderSearchWrapper from './HeaderSearchWrapper.vue';
    import {LogoWrapper} from '@/logged/common/ui';
    import HeaderAvailability from './HeaderAvailability.vue';
    import {useCurrentPage} from '../composables';
    import HeaderSingleLogout from './HeaderSingleLogout.vue';
    import {useFreelancerCompany} from '@/logged/features/header-menu/composables/useFreelancerCompany';
    import HeaderPunchout from './HeaderPunchout.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {

    const userStore = useUser();
    const {isDisplayMobile} = useDisplayMobile();
    const asideMenuStore = useAsideMenu();
    const headerMenuStore = useHeaderMenu();
    const displayModeStore = useDisplayMode();

    const {freelancerCompany} = storeToRefs(useFreelancerCompany());
    const {isDisplayModeFunnel, isDisplayModeFull} = storeToRefs(displayModeStore);
    const {searchDisplayMode, headerNavigationTabs} = storeToRefs(headerMenuStore);
    const isPunchoutBadgeFfEnabled = computed<boolean>(() => !!userStore.user?.featureFlags['navbar-punchout-badge']);
    const isPunchoutEnabled = computed<boolean>(() => userStore.selectedIdentity?.punchoutDetails?.punchoutEnabled === true);

    function handleChangeNavBarDisplayMode() {
        if (isDisplayMobile.value) {
            asideMenuStore.toggleMobileNavBarOpened();
        } else {
            displayModeStore.toggleNavBarDisplayMode();
        }
    }
    const {currentPage} = useCurrentPage();
    const searchFreelancerDisplayHandler = computed(() => userStore.hasSelectedFreelanceIdentity && currentPage.value?.name === 'Search');

    const showSingleLogout = computed(() => freelancerCompany.value.showLogoutButton);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header-menu flex", {isMobile: _unref(isDisplayMobile)}])
  }, [
    (_unref(isDisplayModeFunnel))
      ? (_openBlock(), _createBlock(_unref(LogoWrapper), { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(isDisplayModeFunnel))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            "data-testid": "navbar-toggle-state",
            onClick: handleChangeNavBarDisplayMode
          }, [
            _createVNode(HeaderMenuItem, {
              title: _unref(isDisplayModeFull) ? 'Reduce the navigation bar' : 'Expand the navigation bar',
              icon: "header/burger",
              "can-be-active": false,
              size: 26,
              "show-title": false
            }, null, 8, ["title"])
          ]),
          _createElementVNode("a", _hoisted_2, [
            (_unref(isDisplayMobile))
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (!_unref(isDisplayMobile) && (searchFreelancerDisplayHandler.value || (_unref(userStore).hasSelectedClientIdentity && _unref(searchDisplayMode) !== 'NONE')))
            ? (_openBlock(), _createBlock(HeaderSearchWrapper, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(userStore).hasSelectedFreelanceIdentity)
            ? (_openBlock(), _createBlock(HeaderAvailability, { key: 1 }))
            : _createCommentVNode("", true),
          (isPunchoutBadgeFfEnabled.value && isPunchoutEnabled.value)
            ? (_openBlock(), _createBlock(HeaderPunchout, { key: 2 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerNavigationTabs), (menu) => {
              return (_openBlock(), _createBlock(HeaderMenuItem, {
                key: menu.id,
                tab: menu
              }, null, 8, ["tab"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (showSingleLogout.value)
      ? (_openBlock(), _createBlock(HeaderSingleLogout, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(isDisplayMobile) && (searchFreelancerDisplayHandler.value || (_unref(userStore).hasSelectedClientIdentity && _unref(searchDisplayMode) !== 'NONE')))
      ? (_openBlock(), _createBlock(HeaderSearchWrapper, {
          key: 3,
          class: "isMobile"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})